import { useHistoryDismiss } from './use-history-dismiss.js';

/**
 * THE PHONE'S BACK CLEARS A SELECTION (0.1.527; maintainer, 2 Oct 2026: "when I have items selected,
 * make it so that my android back button clears my item selection, this should be app wide").
 *
 * Rendered ONLY while something is ticked (`{selected.size > 0 && <SelectionBackGuard … />}`): it
 * joins the same history coordinator the sheets use (`use-history-dismiss.ts`), so a Back press with
 * ticks pops the guard's sentinel and clears instead of leaving the screen, and a sheet opened ABOVE
 * a selection still closes first (one stack). Clearing by any other means unmounts it, which
 * consumes the sentinel — the next Back leaves the screen as normal. `goBack` (router.ts) steps over
 * the sentinel, so a back chip pressed with ticks still goes back.
 */
export function SelectionBackGuard({ onClear }: { onClear: () => void }): null {
  useHistoryDismiss(onClear);
  return null;
}
